import axios from "@/api";

export const fetchProductsWithOffers = async ({
  idStore,
  page = 1,
  perPage = 10,
  search = "",
}) => {
  const response = await axios.get("promociones/productos", {
    params: {
      idstore: idStore,
      page,
      per_page: perPage,
      search,
    },
  });

  return response.data;
};

export const fetchProductPromotions = async (productId, idStore) => {
  const response = await axios.get(`promociones/producto/${productId}`, {
    params: { idstore: idStore },
  });

  return response.data;
};

export const syncProductPromotions = async ({
  productId,
  idStore,
  idUser,
  promotions,
}) => {
  const response = await axios.put(`promociones/producto/${productId}`, {
    idStore,
    idUser,
    promotions,
  });

  return response.data;
};

export const resolveSalePromotions = async ({ idStore, details }) => {
  const response = await axios.post("promociones/resolver", {
    idStore,
    details,
  });

  return response.data?.data || [];
};
